import axios from "axios";

const rawUrl = import.meta.env.VITE_API_URL;
const baseURL = rawUrl ? `${rawUrl.replace(/\/+$/, "")}/api` : "/api";

export const api = axios.create({
  baseURL,
  headers: { "Content-Type": "application/json" },
});

let authConfigured = false;



export const setAuthToken = (token: string | null) => {
  if (token) {
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    delete api.defaults.headers.common["Authorization"];
  }
}



export const configureApiAuth = (getToken: () => Promise<string | null>) => {
  if (authConfigured) return;
  authConfigured = true;

  api.interceptors.request.use(async (config) => {
    const token = await getToken();

    if (token) {
      config.headers = config.headers ?? {};
      (config.headers as Record<string, string>).Authorization =
        `Bearer ${token}`;
    } else if (config.headers && "Authorization" in config.headers) {
      delete (config.headers as Record<string, unknown>).Authorization;
    }

    return config;
  });
}
